import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { useAddressRecord } from 'src/graphql';
import { Modals, useModalMethods, useModalState } from 'src/store/modals';
import {
  AddPreSoldMembershipForm,
  AddPreSoldMembershipFormValues,
} from './add-pre-sold-membership-form';
import { preparePreSoldMembershipData, preSoldLengths } from './util';

export interface PsmPayload {
  amount: number;
  intervalUnit: 'month' | 'year';
  intervalCount: number;
  partnerProductId: string;
}

export const AddPreSoldMembershipModal = () => {
  const { closeModal } = useModalMethods(Modals.AddPreSoldMembership);
  const { isOpened, modalProps } = useModalState(Modals.AddPreSoldMembership);
  const { address } = useAddressRecord({ addressId: modalProps?.addressId || '' });

  const formMethods = useForm<AddPreSoldMembershipFormValues>({
    defaultValues: {
      partnerProductId: '',
      price: 0,
      lengthInMonths: preSoldLengths[0].value,
    },
  });

  const onSubmit = useCallback(
    async (data: AddPreSoldMembershipFormValues) => {
      if (!address?.addressId || !address?.partnerId) {
        return;
      }

      const psmPayload = preparePreSoldMembershipData(data);

      closeModal();

      await modalProps?.addPsmToSchedule?.({
        addressId: address?.addressId,
        partnerId: address?.partnerId,
        preSoldMembership: psmPayload,
      });
    },
    [address?.addressId, address?.partnerId, closeModal, modalProps],
  );

  const handleClose = useCallback(() => {
    formMethods.reset();
    closeModal();
  }, [closeModal, formMethods]);

  return (
    <Dialog open={isOpened} onClose={handleClose} fullWidth>
      <DialogTitle>
        <Typography>Add Pre-Sold Membership</Typography>
      </DialogTitle>
      <DialogContent>
        <AddPreSoldMembershipForm
          formMethods={formMethods}
          address={address}
          onSubmit={modalProps?.onSubmit || onSubmit}
        />
      </DialogContent>
    </Dialog>
  );
};
